import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { LoginUser, ResetUser } from './store/actions';

import './assets/styles/Login.scss';
import WCLogo from '../../assets/images/wc-logo';
import Loader from '../commons/assets/loader';

function Login() {
  const authuser = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  useEffect(() => {
    dispatch(ResetUser({}))
  }, [])


  useEffect(() => {
    if (authuser) {
      if (authuser.data && authuser.data.otp_sent) {
        navigate('/verifyUser');
      }
    }
  }, [authuser]);

  const loginSubmit = async () => {
    dispatch(LoginUser({ email: email.trim() }));
  };


  return (
    <div className={'login_container'}>

      <div className="card">
        <WCLogo />
        {authuser && authuser.error && <div className='error'>You Dont have access to Wellness Coach Dashboard</div>}
        <div className='card-title'>Wellness Coach KPI Dashboard</div>
        <div className='control'>
          <input name="email" placeholder='Please enter your company email' onChange={e => setEmail(e.target.value)}></input>
        </div>
        {authuser?.loading ? (
          <Loader />
        ) : (
          <button
            className='button active'
            type='button'
            disabled={!email}
            onClick={loginSubmit}
          >
            <span>Sign In</span>
          </button>
        )}
      </div>
    </div>
  );
}

export default Login;
